import React, { useState, useEffect } from 'react';
import {
  Tooltip,
  IconButton,
} from '@material-ui/core';
import CategoriesTable from './components/DataTable.readonly';
import newButton from '../../assets/img/iconos/newButton.svg';
import reload from '../../assets/img/iconos/reload.svg';
import ActionForm from './components/ActionForm.readonly';
import {
  getCategoryService,
} from '../../services';
import { Loading, Toaster } from '../../components';

const PromoCategoriesScreen = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [popUpAction, setPopUpAction] = useState({ open: false, title: '', data: null });
  const defaultData = {
    nameCategory: ' ',
    icon_base64: ' ',
    icon: '',
    order: 1,
  };
  const [defaultValues, setDefaultValues] = useState(defaultData);
  const [alert, setAlert] = useState({ status: false, type: '', message: '' });

  const getCategories = async () => {
    if (categories.length === 0) {
      setLoading(true);
    }
    try {
      const res = await getCategoryService();
      if (res.status >= 300) {
        setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error al cargar el historial de promociones.' });
      } else {
        const dataOrder = res?.data.sort((a, b) => {
          if (a.order < b.order) {
            return -1;
          }
          return true;
        });
        setCategories(dataOrder);
      }
    } catch (e) {
      setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error al cargar el historial de promociones.' });
    }
    setLoading(false);
  };

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <>
      {loading && <Loading />}
      <>
        <Tooltip title="Refrescar página" aria-label="Refrescar página">
          <IconButton
            onClick={getCategories}
            style={{ fontSize: '20px', float: 'right' }}
            edge="end"
            size="small"
            disabled={false}
          >
            <img src={reload} alt="reload" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Crear nueva categoria" aria-label="Crear nueva categoria">
          <IconButton
            style={{ fontSize: '20px', float: 'right' }}
            edge="end"
            size="small"
            disabled
          >
            <img src={newButton} alt="newButton" style={{ opacity: 0.4 }} />
          </IconButton>
        </Tooltip>
      </>
      <CategoriesTable
        categories={categories}
        setPopUpAction={setPopUpAction}
        setDefaultValues={setDefaultValues}
      />
      <ActionForm
        open={popUpAction.open}
        data={popUpAction.data}
        title={popUpAction.title}
        setDefaultValues={setDefaultValues}
        defaultValues={
          {
            ...defaultValues,
          }
        }
        onClose={() => {
          setPopUpAction({ open: false, title: '', data: null });
        }}
        setAlertHome={setAlert}
      />
      <Toaster
        show={alert.status}
        type={alert.type}
        text={alert.message}
        onClose={() => setAlert({ ...alert, status: false })}
      />
    </>
  );
};

export default PromoCategoriesScreen;
